module.exports = __webpack_public_path__ + "img/logo.ab47dcf1.png";